/**
 * This method returns undefined.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 47 bytes
 * - Micro-dash: 14 bytes
 */
export function noop(): void {}
